<template>
    <input type="text" class="input-tags">
</template>

<script>
export default {
    name: "InputTags",

    props: {
        value: String,
        placeholder: {
            type: String,
            default: "+ Add"
        }
    },

    watch: {
        value(value) {
            $(this.$el).importTags(value);
        }
    },

    mounted() {
        // Initialize the plugin
        this.$nextTick(() => {
            $(this.$el)
            .tagsInput({ 
                width: 'auto', 
                height: 'auto',
                defaultText: this.placeholder,
                removeWithBackspace: false,
                onChange: () => this.update()
            });

            // If given an initial value
            if(this.value?.length > 0) {
                $(this.$el).importTags(this.value);
            }
        });
        
        return;

        // This initializes the input tags plugin only when the input is actually visible on the screen
        // The plugin doesn't seem to work if it starts out in an element with "display: none"
        // For now, there aren't any situations that require this functionality, so I'm leaving it out for simplicity
        let observer = new IntersectionObserver((entries) => this.initTags(entries), {
            root: null,
            rootMargin: "0px",
            threshold: 1.0
        });
        observer.observe(this.$el);
    },

    methods: {
        update() {
            this.$emit('input', this.$el.value);
        },

        initTags(entries) {
            if(entries[0].intersectionRatio == 1) {
                // Initialize the plugin
                $(this.$el)
                .tagsInput({ 
                    width: 'auto', 
                    height: 'auto',
                    defaultText: this.placeholder,
                    removeWithBackspace: false,
                    onChange: () => this.update()
                });

                // If given an initial value
                if(this.value?.length > 0) {
                    $(this.$el).importTags(this.value);
                }
            }
        }
    }
}
</script>

<style>

</style>